import { ArrowRight, Paperclip, RefreshCw, Vibrate } from "lucide-react";
import { Link } from "react-router-dom";
import { PhoneMock } from "../common/ui";
import AppStore from "../../../assets/app-store.png";
import PlayStore from "../../../assets/google-play.png";
import dashboardScreen from "../../../assets/mobile-app/app-dashboard-defects.webp";
import secondScreen from "../../../assets/mobile-app/app-defects.webp";

// Same features as the /mobile-app page, cut to the three that sell the app fastest.
const perks = [
  { icon: Vibrate, text: "Shake to report a bug in under a minute" },
  { icon: RefreshCw, text: "Always in sync with the web app" },
  { icon: Paperclip, text: "Attach screenshots, logs and files on the go" },
];

// Home page band for the mobile app: copy and store links beside two phones that rise
// out of a brand-tinted panel.
export default function Store() {
  return (
    <section className="ft-section ft-section--tight">
      <div className="ft-container">
        <div className="home-store">
          <div className="home-store__copy">
            <span className="ft-eyebrow">Mobile app</span>
            <h2 className="home-store__title">
              Download <span>Froth TestOps</span>
            </h2>
            <p className="home-store__lead">Report bugs, browse tests and stay in sync from your phone.</p>

            <ul className="home-store__perks">
              {perks.map(({ icon: Icon, text }) => (
                <li key={text}>
                  <span className="home-store__perk-icon">
                    <Icon size={16} aria-hidden="true" />
                  </span>
                  {text}
                </li>
              ))}
            </ul>

            <div className="home-store__actions">
              <div className="home-store__badges">
                <a
                  href="https://play.google.com/store/apps/details?id=ytlc.frothtestops.com.testops"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={PlayStore} alt="Get it on Google Play" />
                </a>
                <a href="https://apps.apple.com/in/app/frothtestops/id6746042634" target="_blank" rel="noopener noreferrer">
                  <img src={AppStore} alt="Download on the App Store" />
                </a>
              </div>
              <Link className="home-store__more" to="/mobile-app">
                About the mobile app <ArrowRight size={15} aria-hidden="true" />
              </Link>
            </div>
          </div>

          <div className="home-store__visual" aria-hidden="true">
            <div className="home-store__phones">
              <PhoneMock src={secondScreen} alt="" className="home-store__phone home-store__phone--back" />
              <PhoneMock src={dashboardScreen} alt="" className="home-store__phone home-store__phone--front" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
